// init cookie layer
import '@/components/cookie-layer/cookie-layer.scss'
import CookieLayer from '@/components/cookie-layer/cookie-layer'

CookieLayer.initialize()